<template>
  <div class="archives-teacher">
    <div class="yj-archives-query">
      <header class="header wrapper">
        <div class="yj-query-r">
          <el-select v-model="gradeId" @change="handleCurrentChange(1)" placeholder="年级"
            style="width: 106px;margin-right: 4px;" :clearable="!!userInfo.isAdmin" size="mini">
            <el-option v-for="item in gradeList" :key="item.id" :label="item.gradeName" :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="classId" @change="handleCurrentChange(1)" placeholder="班级"
            style="width: 106px;margin-right: 4px;" clearable size="mini">
            <el-option v-for="item in classList" :key="item.id" :label="item.className" :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="subjectCode" @change="handleCurrentChange(1)" placeholder="学科"
            style="width: 106px;margin-right: 4px;" clearable size="mini">
            <el-option v-for="item in subjectList" :key="item.id" :label="item.subjectName" :value="item.subjectCode">
            </el-option>
          </el-select>
          <el-input v-model="nickName" placeholder="教师姓名" style="width: 120px;margin-right: 4px;" clearable
            size="mini"></el-input>
          <el-button type="primary" size="mini" plain :loading="loading" @click="handleCurrentChange(1)">
            查询
          </el-button>
        </div>
      </header>
    </div>
    <div class="table-wrap wrapper">
      <el-table :data="teacherList" v-loading="loading" size="mini" border>
        <el-table-column prop="nickName" align="center" label="教师姓名"></el-table-column>
        <el-table-column prop="tel" align="center" label="手机号"></el-table-column>
        <el-table-column align="center" label="学科">
          <template slot-scope="scope">
            <div class="cell" v-for="(s, index) in scope.row.teacherRoleVos" :key="index">{{ s.subjectName || '全部学科' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="className" align="center" label="当前年级/班级">
          <template slot-scope="scope">
            <div class="cell" v-for="(g, index) in scope.row.teacherRoleVos" :key="index">
              <template v-if="g.gradeName">
                {{ g.gradeName }}
                <template v-if="g.className">
                  {{ g.className }}班
                </template>
              </template>
              <template v-else>
                全部年级
              </template>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="studNumInClass" align="center" label="当前所带学生数"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="normal" @click="seeDetail(scope.row)">查看档案</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <zj-pagination @current-change="handleCurrentChange"
          :page="{ current: currentPage, total: total }"></zj-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getAuthGradeList, getGradeClassList, queryTeacherSubject, getArchivesTeacherList } from '@/api/api'
import { mapGetters } from "vuex"
import ZjPagination from '@/pages/zujuan/components/ZjPagination.vue'

export default {
  components: {
    ZjPagination
  },
  data () {
    return {
      loading: false,
      gradeId: '',
      gradeList: [],
      classId: '',
      classList: [],
      subjectCode: '',
      subjectList: [],
      nickName: '',
      teacherList: [],
      total: 0,
      currentPage: 1
    }
  },

  computed: {
    ...mapGetters({
      userInfo: "getUserInfo"
    })
  },

  watch: {
    gradeId (val) {
      if (val) {
        this.getGradeClassList()
        this.getSubjectList()
      } else {
        this.classId = ''
        this.subjectCode = ''
      }
    },
  },

  mounted () {
    this.getAuthGradeList()
    // this.getTeacherList()
  },

  methods: {
    //获取年级列表
    async getAuthGradeList () {
      let resp = await getAuthGradeList({
        schoolId: this.userInfo.schoolId,
        academicYear: this.userInfo.academicYear
      })

      if (resp.success && resp.body && Array.isArray(resp.body) && resp.body.length > 0) {
        this.gradeList = resp.body

        if (this.userInfo.isAdmin) {
          this.getTeacherList()
        } else {
          this.gradeId = resp.body[0].id
          this.getTeacherList()
        }
      }
    },

    //获取班级列表
    async getGradeClassList () {
      let resp = await getGradeClassList({
        gradeId: this.gradeId
      })

      if (resp.body) {
        this.classList = resp.body
      }
    },

    async getSubjectList () {
      let resp = await queryTeacherSubject({
        gradeId: this.gradeId
      })
      if (resp.code === 200 && resp.data) {
        let data = resp.data.obj
        this.subjectList = data
      } else {
        this.$message.error(resp.msg)
      }
    },

    ///获取学生列表
    async getTeacherList () {
      let params = {
        classType: 0,
        chooseSchoolId: this.userInfo.schoolId,
        schoolId: this.userInfo.schoolId,
        nickName: this.nickName,
        gradeId: this.gradeId,
        classId: this.classId,
        subjectCode: this.subjectCode,
        pageSize: 10,
        currentPage: this.currentPage,
        useStatus: 1,
        roles: ['SCHOOL_TEACHER']
      }

      this.loading = true
      let resp = await getArchivesTeacherList(params)
      this.loading = false

      if (resp.body) {
        this.teacherList = resp.body.items
        this.total = resp.body.totalSize
      } else {
        this.$message.error(resp.message)
      }
    },

    handleCurrentChange (val) {
      this.currentPage = val
      this.getTeacherList()
    },

    seeDetail (row) {
      this.$router.push({
        path: `/study/archives/teacher/detail?teacherId=${row.id}`
      })
    },
  }
}
</script>


<style scoped lang="scss">
.yj-archives-query {
  height: 40px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: right;
  margin-bottom: 15px;
}

.yj-archives-query ::v-deep .el-select,
.yj-archives-query ::v-deep .el-input--mini .el-input__inner {
  height: 26px;
  font-size: 14px;
  color: #999999;
}

.yj-archives-query ::v-deep .el-input--mini .el-input__inner {
  padding: 0 10px;
}

.yj-archives-query ::v-deep .el-button--primary:not(.is-disabled).is-plain {
  background-color: white;
  color: #2877FF;
  border-color: #2877FF;
  height: 26px;
  font-size: 14px;
  line-height: 12px;
  border-radius: 4px;
}

.archives-teacher {
  padding: 40px 0;
}
.archives-teacher .wrapper {
  margin: 0 20px;
}

.archives-teacher .yj-query-r {
  float: right;
  padding-right: 15px;
}

.table-wrap {
  padding: 20px;
  background: #fff;
  border-radius: 6px;

  .pagination {
    text-align: right;
    padding: 15px 0 5px;
  }
}
</style>

<style>
.archives-teacher_route .container {
  width: 100% !important;
  margin: auto !important;
}
</style>
